(function () {

  function initViewedSwiper() {

    const container = document.querySelector(".sa-079-ur-viewed-products");
    if (!container) return;

    if (container.classList.contains("swiper-initialized")) return;

    const items = container.querySelectorAll(".sa-079-ur-viewed-products-grid-item");
    if (!items.length) return;

    /* grid解除 */
    container.classList.remove(
      "sa-079-ur-viewed-products-grid",
      "sa-079-ur-viewed-products-grid--4-col-desktop",
      "sa-079-ur-viewed-products-grid--2-col-mobile-down"
    );

    container.style.display = "block";
    container.classList.add("swiper");

    const wrapper = document.createElement("div");
    wrapper.className = "swiper-wrapper";

    items.forEach(item => {
      item.classList.add("swiper-slide");
      wrapper.appendChild(item);
    });

    container.innerHTML = "";
    container.appendChild(wrapper);

    /* 🔥 ナビゲーションUI追加 */
    const navWrapper = document.createElement("div");
    navWrapper.className = "section-header__button-arrow";

    const prev = document.createElement("button");
    prev.className = "swiper-button swiper-button-prev";
    prev.setAttribute("aria-label", "Previous slide");

    prev.innerHTML = `
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none" class="icon icon-arrow-big">
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M16.9455 23.707L34.5313 23.707L34.5313 25.707L16.9455 25.707L23.2384 31.9998L21.8241 33.4141L13.8241 25.4141L13.117 24.707L13.8241 23.9998L21.8241 15.9999L23.2384 17.4141L16.9455 23.707Z"
          fill="currentColor"></path>
      </svg>
    `;

    const next = document.createElement("button");
    next.className = "swiper-button swiper-button-next";
    next.setAttribute("aria-label", "Next slide");

    next.innerHTML = `
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none" class="icon icon-arrow-big">
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M31.5858 25.7071H14V23.7071H31.5858L25.2929 17.4142L26.7071 16L34.7071 24L35.4142 24.7071L34.7071 25.4142L26.7071 33.4142L25.2929 32L31.5858 25.7071Z"
          fill="currentColor"></path>
      </svg>
    `;

    navWrapper.appendChild(prev);
    navWrapper.appendChild(next);
    container.parentNode.insertBefore(navWrapper, container.nextSibling);

    /* Swiper初期化 */
    new Swiper(container, {
      slidesPerView: 4,
      slidesPerGroup: 1,
      spaceBetween: 20,
      loop: false,
      navigation: {
        nextEl: next,
        prevEl: prev,
      },
      breakpoints: {
        0: { slidesPerView: 2 },
        768: { slidesPerView: 4 }
      }
    });

  }

  const observer = new MutationObserver(() => {
    if (document.querySelector(".sa-079-ur-viewed-products-grid-item")) {
      initViewedSwiper();
      observer.disconnect();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

})();